import { createMasterKids } from 'lib/api/contract';
import { useMutation, useQueryClient } from 'react-query';
import { useEffect, useState } from 'react';
import { validateMasterKidRegisterForm } from 'utils/validate';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useMasterKidsCreator = ({ closeModal, masterId }) => {
  const queryClient = useQueryClient();

  const [registerForm, setRegisterForm] = useState({
    userId: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [isAdd, setIsAdd] = useState(false);

  const createMasterKidsMutation = useMutation(createMasterKids, {
    onError: error => {
      if (error.response.data.error === 'AlreadyUsereExist') {
        setErrors({ ...errors, serverError: error.response.data.msg });
        return;
      }
    },
    onSuccess: () => {
      closeModal();
      queryClient.invalidateQueries('contract');
    },
  });
  useLoginCheck(createMasterKidsMutation.error?.response, () => {
    createMasterKidsMutation.mutate({
      masterId,
      masterKids: {
        userId: registerForm.userId,
        password: registerForm.password,
      },
    });
  });

  useEffect(() => {
    if (isAdd && Object.keys(errors).length === 0) {
      createMasterKidsMutation.mutate({
        masterId,
        masterKids: {
          userId: registerForm.userId,
          password: registerForm.password,
        },
      });
      setIsAdd(false);
    }
  }, [isAdd, errors, createMasterKidsMutation, masterId, registerForm]);

  useEffect(() => {
    return () =>
      setRegisterForm({
        userId: '',
        password: '',
      });
  }, []);

  const onAdd = () => {
    setIsAdd(true);
    setErrors(
      validateMasterKidRegisterForm(registerForm.userId, registerForm.password),
    );
  };

  const onChange = e => {
    const { name, value } = e.target;
    setRegisterForm({ ...registerForm, [name]: value });
  };

  return {
    registerForm,
    errors,
    createMasterKidsMutation,
    onChange,
    onAdd,
  };
};

export default useMasterKidsCreator;
